import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Cart from '../views/Cart.vue'
import Transaction from '../views/Transaction.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/product/:productId',
    name: 'Product',
    component: ProductDetail
  },
  {
    path: '/carts',
    name: 'Cart',
    component: Cart,
    meta: {requiresAuth: true}
  },
  {
    path: '/transactions',
    name: 'Transaction',
    component: Transaction,
    meta: {requiresAuth: true}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next({name: 'Home'})
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
